"use strict";

var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lookupRecord = _interopRequireDefault(require("../helpers/lookupRecord"));
var _BRRenderer = _interopRequireDefault(require("../renderers/BRRenderer"));
var _WBRRenderer = _interopRequireDefault(require("../renderers/WBRRenderer"));
var _internalRenderers = _interopRequireDefault(require("./internalRenderers"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var internalTextRenderers = {
  br: _BRRenderer.default,
  wbr: _WBRRenderer.default
};
var RenderRegistry = /*#__PURE__*/function () {
  function RenderRegistry() {
    var customRenderers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var elementModels = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, RenderRegistry);
    _defineProperty(this, "customRenderers", {});
    _defineProperty(this, "elementModels", void 0);
    this.customRenderers = customRenderers;
    this.elementModels = elementModels;
  }
  _createClass(RenderRegistry, [{
    key: "getCustomRendererForTNode",
    value: function getCustomRendererForTNode(tnode) {
      if (tnode.tagName in this.customRenderers) {
        var renderer = this.customRenderers[tnode.tagName];
        /* istanbul ignore next */

        if (typeof __DEV__ === 'boolean' && __DEV__) {
          // In DEV, check for discrepancies.
          var elementModel = this.elementModels[tnode.tagName];
          if (!elementModel) {
            console.warn("You are attempting to render a ".concat(tnode.tagName, " tag but you didn't provide an HTMLElementModel. Make sure you register a model for this tag in \"customHTMLElementModels\" prop. "));
          } else if (!tnode.matchContentModel(elementModel.contentModel)) {
            console.warn("You are attempting to render \"".concat(tnode.tagName, "\" of type \"").concat(tnode.displayName, "\", but the registered renderer is of content model type ").concat(elementModel === null || elementModel === void 0 ? void 0 : elementModel.contentModel, " which is incompatible with \"").concat(tnode.displayName, "\"."));
          }
        }
        return renderer;
      }
      return null;
    }
  }, {
    key: "getDefaultRendererForTNode",
    value: function getDefaultRendererForTNode(tnode) {
      if (tnode.tagName in _internalRenderers.default) {
        //@ts-expect-error we know that the tagName is in the map
        return _internalRenderers.default[tnode.tagName];
      }
      return null;
    }
  }, {
    key: "getInternalTextRenderer",
    value: function getInternalTextRenderer(tagName) {
      if ((0, _lookupRecord.default)(internalTextRenderers, tagName)) {
        return internalTextRenderers[tagName];
      }
      return null;
    }
  }, {
    key: "getRendererConfigForTNode",
    value: function getRendererConfigForTNode(tnode) {
      return {
        Custom: this.getCustomRendererForTNode(tnode),
        Default: this.getDefaultRendererForTNode(tnode)
      };
    }
  }]);
  return RenderRegistry;
}();
exports.default = RenderRegistry;